/* eslint-disable */

export const subscriptionTypes = {
  light: "Light",
  advanced: "Advanced",
  expert: "Expert"
};

const { light, advanced, expert } = subscriptionTypes;

export const permissions = {
  audienceOverview: {
    view: [light, advanced, expert]
  },
  pushes: {
    view: [light, advanced, expert]
  },
  audienceBuilder: {
    view: [advanced, expert]
  },
  preCampaignReport: {
    view: [advanced, expert]
  },
  customerAnalysis: {
    view: [advanced, expert]
  },
  clientSection: {
    view: [advanced, expert]
  },
  advancedReporting: {
    view: [expert]
  },
  ownCompanySkin: {
    view: [expert]
  }
};
